<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="form-group row mb-3">
                <div class="col-md-3">
                    <app-select-academic-year-only
                    (academicYearChanged)="onChangeAcademicYear($event); clearData()">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-3">
                    <app-select-school-level-relation-v2
                    [academic_year]="this.paramForm.get('academic_year')?.value"
                    (schoolLevelRelationChanged)="onChangeSchoolLevel($event); clearData()"
                    [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-3">
                    <app-select-school-program
                    [academic_year]="this.paramForm.get('academic_year')?.value"
                    [school_location_id]="this.paramForm.get('school_location_id')?.value"
                    [isDisabled]="!this.paramForm.get('school_location_id')?.value"
                    (schoolProgramChanged)="onChangeSchoolProgram($event); clearData()">
                    </app-select-school-program>
                </div>
                <div class="col-md-3">
                    <app-select-school-program-category
                    [school_program_id]="this.paramForm.get('school_program_id')?.value"
                    [isDisabled]="!this.paramForm.get('school_program_id')?.value"
                    [all]="true"
                    (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event); clearData()">
                    </app-select-school-program-category>
                </div>
                <div class="col-md-3">
                    <app-select-school-activity
                    (schoolActivityChanged)="onChangeSchoolProgramActivity($event)"
                    [academic_year]="this.paramForm.get('academic_year')?.value"
                    [school_program_id]="this.paramForm.get('school_program_id')?.value"
                    [school_program_category_id]="this.paramForm.get('school_program_category_id')?.value"
                    [has_payment]="true"
                    [isDisabled]="!paramForm.get('school_program_category_id')?.value">
                    </app-select-school-activity>
                </div>
            </div>

            <div class="form-group row mb-3" *ngIf="paramForm.get('school_program_activity_id')?.value">
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                        <mat-label>Search</mat-label>
                        <input matInput [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" placeholder="Search student name...">
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                        <mat-label>Payment Method</mat-label>
                        <mat-select [(ngModel)]="isManualPayment" (ngModelChange)="onFilterChange()">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option [value]="true">Manual</mat-option>
                            <mat-option [value]="false">Virtual Account</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-3">
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                        <mat-label>VA Generated</mat-label>
                        <mat-select [(ngModel)]="filterVaGenerated" (ngModelChange)="onFilterChange()">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field appearance="outline" class="w-100 filter-field">
                        <mat-label>Paid</mat-label>
                        <mat-select [(ngModel)]="filterPaid" (ngModelChange)="onFilterChange()">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="table-container" *ngIf="paramForm.get('school_program_activity_id')?.value">
                <table mat-table *ngIf="data && data.length > 0 && !loading.list"
                       [dataSource]="dataSource" multiTemplateDataRows
                       class="mat-elevation-z8 full-width-table">

                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef style="width: 48px; padding-right: 8px;">
                            <mat-checkbox
                                [checked]="isAllSelected()"
                                [indeterminate]="hasSelection && !isAllSelected()"
                                (change)="toggleSelectAll()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element" style="width: 48px; padding-right: 8px;">
                            <mat-checkbox
                                [checked]="isSelected(element.registration_payment_id)"
                                (change)="toggleSelection(element.registration_payment_id)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="student_name">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'STUDENT_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.student_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="is_paid">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'IS_PAID' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.is_paid ? 'Yes' : '-' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_generated">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_GENERATED' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.payment_generated ? 'Yes' : 'No' }}
                        </td>
                    </ng-container>
                    
                    <ng-container matColumnDef="total_fee">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'TOTAL_FEE' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.total_fee | currency:'IDR':'Rp'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_amount">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_AMOUNT' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.payment_amount || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_date">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer" (click)="onSortPaymentDate()" style="user-select: none;">
                            {{ 'PAYMENT_DATE' | translate }}
                            <span *ngIf="sortDirection === 'asc'"> &#9650;</span>
                            <span *ngIf="sortDirection === 'desc'"> &#9660;</span>
                        </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{(element.payment_date | date:'medium') || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_notes">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_NOTES' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.payment_notes || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_logs">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_LOGS' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            <button class="action-btn action-btn-view" (click)="openPaymentLogsModal(element.registration_payment_id)" matTooltip="View Payment Logs">
                                <i class="fa fa-history me-1"></i> Logs
                            </button>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'ACTION' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            <div class="d-flex justify-content-evenly gap-2">
                                @if (loading.approve && !element.is_paid) {
                                    <span class="spinner-border spinner-border-sm me-1"></span>
                                } @else if (!element.is_paid && auth.permissions['SCHOOL_PROGRAM_ADMIN_APPROVE_MANUAL_PAYMENT']) {
                                    <i class="fa fa-circle-check text-success fs-3 cursor-pointer approval-icon" matTooltip="Approve Latest Payment" (click)="onApprovePayment(true, element.registration_payment_id)"></i>
                                    <i class="fa fa-circle-xmark text-danger fs-3 cursor-pointer approval-icon" matTooltip="Reject Latest Payment" (click)="onApprovePayment(false, element.registration_payment_id)"></i>
                                } @else {
                                    <p>-</p>
                                }
                            </div>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
            </div>

            <div class="d-flex justify-content-end mt-2 mb-2 gap-2" *ngIf="hasSelection">
                <button class="btn btn-danger" (click)="onApprovePayment(false)" [disabled]="loading.approve">
                    <span *ngIf="loading.approve" class="spinner-border spinner-border-sm me-1"></span>
                    {{ 'REJECT_ALL_PAYMENT' | translate }}
                </button>
                <button class="btn btn-success" (click)="onApprovePayment(true)" [disabled]="loading.approve">
                    <span *ngIf="loading.approve" class="spinner-border spinner-border-sm me-1"></span>
                    {{ 'APPROVE_ALL_PAYMENT' | translate }}
                </button>
            </div>

            <mat-paginator
                *ngIf="totalItems > 0"
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageIndex]="page - 1"
                [pageSizeOptions]="[10, 25, 50, 100]"
                (page)="onPageChanged($event)"
                showFirstLastButtons>
            </mat-paginator>

        </div>
    </mat-card-content>
</mat-card>

<ng-template #paymentLogsModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="payment-logs-modal-title">
            <i class="fa fa-history me-2"></i>
            {{ 'PAYMENT_LOGS' | translate }}
        </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <app-payment-manual-logs-table
            [registrationPaymentId]="selectedLogsPaymentId">
        </app-payment-manual-logs-table>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
            Close
        </button>
    </div>
</ng-template>

<ng-template #confirmModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title" id="confirm-modal-title">
            <i class="fa me-2"
               [class.fa-circle-check]="pendingApprove"
               [class.fa-circle-xmark]="!pendingApprove"
               [class.text-success]="pendingApprove"
               [class.text-danger]="!pendingApprove">
            </i>
            {{ (pendingApprove ? 'APPROVE_PAYMENT' : 'REJECT_PAYMENT') | translate }}
        </h5>
        <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        <p class="mb-3">
            {{ (pendingApprove ? 'APPROVE_PAYMENT_CONFIRM' : 'REJECT_PAYMENT_CONFIRM') | translate }}
            <strong>({{ pendingIds.length }} {{ 'ITEM' | translate }})</strong>
        </p>

        <div *ngIf="!pendingApprove">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>{{ 'REJECT_NOTE' | translate }}</mat-label>
                <textarea matInput
                          [(ngModel)]="rejectNote"
                          rows="4"
                          placeholder="{{ 'REJECT_NOTE_PLACEHOLDER' | translate }}">
                </textarea>
            </mat-form-field>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.close(false)">
            {{ 'CANCEL' | translate }}
        </button>
        <button type="button"
                class="btn"
                [class.btn-success]="pendingApprove"
                [class.btn-danger]="!pendingApprove"
                [disabled]="!pendingApprove && !rejectNote?.trim()"
                (click)="modal.close(true)">
            {{ (pendingApprove ? 'APPROVE' : 'REJECT') | translate }}
        </button>
    </div>
</ng-template>
